import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';
import Text from 'shopper/components/Text';

import CommercialContactForm from 'components/CommercialContactForm';
import Image from 'components/Image';

import useModal from 'hooks/useModal';

import APP from 'constants/app';

const SuccessModal = dynamic(
  () => import('components/CommercialContactForm/SuccessModal'),
  { ssr: false }
);

const BePartner = ({ gaEventCategory }) => {
  const { showModal } = useModal();

  return (
    <section id="fazer_parceria">
      <Heading className="mb-16 text-center" size="size2">
        Ficou interessado em uma{' '}
        <Heading as="span" className="text-gradient-highlight" size="size2">
          futura parceria
        </Heading>
        ?
        <br />
        Entre em contato com{' '}
        <Heading as="span" className="text-gradient-highlight" size="size2">
          nosso time comercial
        </Heading>{' '}
        para mais detalhes:
      </Heading>
      <div className="mt-4 flex flex-col items-start justify-center gap-x-6 md:flex-row">
        <CommercialContactForm
          className="mt-4"
          gaEventCategory={gaEventCategory}
          submitButtonProps={{ children: 'Enviar mensagem', type: 'secondary' }}
          successMessage="Em breve iremos "
          withWordsCounter
          onSuccess={() => {
            showModal(SuccessModal, {
              actionButtonText: 'Entendi',
              message:
                'Em breve iremos te contatar para falarmos sobre a parceria.',
            });
          }}
        />
        <div>
          <Image
            alt="Pessoa feliz usando o Promobit"
            className="hidden md:block"
            height={488}
            src={`${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/people-using-promobit.png`}
            width={440}
          />
          <Text className="mt-6 max-w-lg md:mt-8">
            Responderemos o mais rápido possível, mas se preferir pode enviar um
            email direto para:{' '}
            <Link
              // TODO: transform this colors into a specific type for Link
              className="text-secondary-300 dark:text-secondary-300"
              href={`mailto:${APP.COMMERCIAL_EMAIL}`}
              type="secondary"
              bold
            >
              {APP.COMMERCIAL_EMAIL}
            </Link>
          </Text>
        </div>
      </div>
    </section>
  );
};

BePartner.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default BePartner;
